import 'custom-event-polyfill';

export default {
    updateUser: ({ firstName, lastName, email, profileImageUrl }) => {
        window.dispatchEvent(new CustomEvent('mf-header:update-user', {
            detail: {
                firstName: `${firstName}`,
                lastName: `${lastName}`,
                email: `${email}`,
                profileImageUrl: `${profileImageUrl}`,
            },
        }));
    },
    updateNotifications: ({
        cv, applications, messages, alarm, jobs, matching, companies,
    }) => {
        window.dispatchEvent(new CustomEvent('mf-header:update-notifications', {
            detail: {
                cv: cv || false,
                applications: applications || false,
                messages: messages || false,
                alarm: alarm || false,
                jobs: jobs || false,
                matching: matching || false,
                companies: companies || false,
            },
        }));
    },
    updateStatus: ({ loading }) => {
        window.dispatchEvent(new CustomEvent('mf-header:update-status', {
            detail: {
                loading: loading || false,
            },
        }));
    },
    updateLoginButton: ({ hidden, targetUrl }) => {
        window.dispatchEvent(new CustomEvent('mf-header:update-loginButton', {
            detail: {
                hidden: hidden || false,
                targetUrl,
            },
        }));
    },
    onReady(callback) {
        window.addEventListener('mf-header:ready', () => {
            window.dispatchEvent(new CustomEvent('mf-header:ready-acknowledged'));
            callback();
        });
    },
    onLoginButtonClick(callback) {
        window.addEventListener('mf-header:click-loginButton', callback);
    },
    onRegisterLinkClick(callback) {
        window.addEventListener('mf-header:click-registerLink', callback);
    },
    onNavigationItemClick(callback) {
        window.addEventListener('mf-header:click-nav-item', callback);
    },
    mountHeader() {
        window.dispatchEvent(new CustomEvent('mf-header:mount'));
    },
};
